// src/services/reports.ts
import api from '../lib/api';

export interface UserReportData {
  id: string;
  name: string;
  email: string;
  type: string;
  status: string;
  connections: number;
  messages: number;
  joined: string;
}

export interface ConnectionReportData {
  id: string;
  requester: string;
  requesterEmail: string;
  receiver: string;
  receiverEmail: string;
  status: string;
  requestedAt: string;
  respondedAt: string;
}

export interface MarketplaceReportData {
  id: string;
  type: string;
  title: string;
  submitter: string;
  email: string;
  status: string;
  industry: string;
  createdAt: string;
}

export interface EngagementReportData {
  id: string;
  name: string;
  email: string;
  type: string;
  messagesSent: number;
  connectionsCreated: number;
  totalConnections: number;
  engagementScore: number;
  lastLogin: string;
}

export const getUserReport = async (dateRange: string = 'last-30-days'): Promise<UserReportData[]> => {
  const response = await api.get('/api/reports/users', {
    params: { dateRange }
  });
  return response.data;
};

export const getConnectionsReport = async (dateRange: string = 'last-30-days'): Promise<ConnectionReportData[]> => {
  const response = await api.get('/api/reports/connections', {
    params: { dateRange }
  });
  return response.data;
};

export const getMarketplaceReport = async (dateRange: string = 'last-30-days'): Promise<MarketplaceReportData[]> => {
  const response = await api.get('/api/reports/marketplace', {
    params: { dateRange }
  });
  return response.data;
};

export const getEngagementReport = async (dateRange: string = 'last-30-days'): Promise<EngagementReportData[]> => {
  const response = await api.get('/api/reports/engagement', {
    params: { dateRange }
  });
  return response.data;
};
